import api from '@/api/axios';
import { ENDPOINTS } from '@/api/endpoints';
import {
  LoginCredentials,
  LoginResponse,
  SignUpData,
  ForgotPasswordData,
  ResetPasswordData,
  User,
} from '@/types';

/**
 * Authentication API service
 * Replaces Angular's AuthService HTTP methods
 */

/**
 * Login user
 */
export const login = async (credentials: LoginCredentials): Promise<LoginResponse> => {
  const response = await api.post<LoginResponse>(ENDPOINTS.AUTH.LOGIN, credentials);
  return response.data;
};

/**
 * Sign up new user (legacy — direct, no OTP)
 */
export const signUp = async (data: SignUpData): Promise<User> => {
  const response = await api.post<User>(ENDPOINTS.AUTH.SIGNUP, data);
  return response.data;
};

/**
 * Step 1: Send OTP to email for verification before account creation
 */
export const sendSignupOtp = async (data: { userEmail: string; userName?: string; password: string }): Promise<{ message: string }> => {
  const response = await api.post<{ message: string }>(ENDPOINTS.AUTH.SIGNUP_SEND_OTP, data);
  return response.data;
};

/**
 * Step 2: Verify OTP and create the account
 */
export const verifyOtpAndSignup = async (data: { userEmail: string; otpCode: string; userName?: string; password: string }): Promise<{ message: string }> => {
  const response = await api.post<{ message: string }>(ENDPOINTS.AUTH.SIGNUP_VERIFY_OTP, data);
  return response.data;
};

/**
 * Request password reset
 */
export const forgotPassword = async (data: ForgotPasswordData): Promise<{ message: string }> => {
  const response = await api.post<{ message: string }>(ENDPOINTS.AUTH.FORGOT_PASSWORD, data);
  return response.data;
};

/**
 * Reset password with token
 */
export const resetPassword = async (data: ResetPasswordData): Promise<{ message: string }> => {
  const response = await api.post<{ message: string }>(ENDPOINTS.AUTH.RESET_PASSWORD, data);
  return response.data;
};

export const authApi = {
  login,
  signUp,
  sendSignupOtp,
  verifyOtpAndSignup,
  forgotPassword,
  resetPassword,
};

export default authApi;
